export default __webpack_public_path__ + "static/media/3590.ef054cd0.png";